import * as Types from '../../../graphql.generated';

export type GetUserPropertyRelationshipQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type GetUserPropertyRelationshipQuery = { __typename?: 'Query' } & {
    user?: Types.Maybe<
        { __typename?: 'User' } & {
            trackedProperties?: Types.Maybe<
                { __typename?: 'UserTrackedProperties' } & {
                    items: Array<
                        { __typename?: 'UserTrackedProperty' } & Pick<
                            Types.UserTrackedProperty,
                            'relationship'
                        > & {
                                property: { __typename?: 'Property' } & Pick<
                                    Types.Property,
                                    'uprn'
                                >;
                            }
                    >;
                }
            >;
        }
    >;
};

export const GetUserPropertyRelationshipDocument = `
    query GetUserPropertyRelationship {
  user {
    trackedProperties(offset: 0, limit: 1) {
      items {
        property {
          uprn
        }
        relationship
      }
    }
  }
}
    `;
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C>(requester: Requester<C>) {
    return {
        GetUserPropertyRelationship(
            variables?: GetUserPropertyRelationshipQueryVariables,
            options?: C
        ): Promise<GetUserPropertyRelationshipQuery> {
            return requester<
                GetUserPropertyRelationshipQuery,
                GetUserPropertyRelationshipQueryVariables
            >(GetUserPropertyRelationshipDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
